const API = `${process.env.REACT_APP_BACKEND_URL || ''}/api/pwa`;
export async function pwaApi(path, options = {}) {
  const r = await fetch(`${API}${path}`, { ...options, cache: 'no-store', credentials: 'include',
    headers: { 'Content-Type': 'application/json', ...(options.headers || {}) } });
  const data = await r.json().catch(() => null);
  if (!r.ok) throw new Error(data?.detail || `Erreur serveur ${r.status}`);
  return data;
}
export const supported = () => window.isSecureContext && 'serviceWorker' in navigator && 'PushManager' in window && 'Notification' in window;
export async function registration() {
  if (!supported()) throw new Error('Notifications indisponibles : utilisez Chrome Android en HTTPS.');
  const existing = await navigator.serviceWorker.getRegistration('/');
  if (existing && !existing.active?.scriptURL.endsWith('/service-worker.js')) {
    throw new Error('Un autre service worker existe : intégration manuelle requise.');
  }
  await navigator.serviceWorker.register('/service-worker.js', { scope: '/', updateViaCache: 'none' });
  return Promise.race([navigator.serviceWorker.ready, new Promise((_, reject) =>
    setTimeout(() => reject(new Error('Activation du service worker trop longue. Rechargez la page.')), 15000))]);
}
const bytes = key => Uint8Array.from(atob(key.replace(/-/g, '+').replace(/_/g, '/') + '='.repeat((4 - key.length % 4) % 4)), c => c.charCodeAt(0));
export async function owner(email) {
  const reg = await registration();
  const hash = email ? [...new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(email)))].map(b => b.toString(16).padStart(2, '0')).join('') : null;
  await new Promise((resolve, reject) => {
    const channel = new MessageChannel();
    const timer = setTimeout(() => { channel.port1.close(); reject(new Error('Service worker sans réponse.')); }, 5000);
    channel.port1.onmessage = () => { clearTimeout(timer); channel.port1.close(); resolve(); };
    reg.active.postMessage({ type: 'PWA_OWNER', owner: hash }, [channel.port2]);
  });
}
export async function enable(email, config) {
  // Appelé uniquement par un clic utilisateur, aucune demande automatique.
  if (await Notification.requestPermission() !== 'granted') throw new Error('Autorisation refusée. Modifiez les réglages du site dans Chrome.');
  const reg = await registration();
  let sub = await reg.pushManager.getSubscription();
  if (sub) {
    const actual = new Uint8Array(sub.options.applicationServerKey || []);
    const wanted = bytes(config.publicKey);
    if (actual.length !== wanted.length || actual.some((b, i) => b !== wanted[i])) {
      await pwaApi('/subscriptions/remove', { method: 'POST', body: JSON.stringify({ endpoint: sub.endpoint }) });
      await sub.unsubscribe(); sub = null;
    }
  }
  if (!sub) sub = await reg.pushManager.subscribe({ userVisibleOnly: true, applicationServerKey: bytes(config.publicKey) });
  await pwaApi('/subscriptions', { method: 'POST', body: JSON.stringify({ subscription: sub.toJSON() }) });
  await owner(email);
}
export async function disable() {
  const reg = await registration();
  const sub = await reg.pushManager.getSubscription();
  // Couper localement même si le serveur est momentanément indisponible.
  await owner(null);
  if (sub) {
    let error;
    try { await pwaApi('/subscriptions/remove', { method: 'POST', body: JSON.stringify({ endpoint: sub.endpoint }) }); } catch (e) { error = e; }
    await sub.unsubscribe();
    if (error) throw new Error('Notifications coupées sur ce téléphone ; désabonnement serveur non confirmé.');
  }
}
export async function disconnectLocalPush() {
  if (!supported()) return;
  const reg = await navigator.serviceWorker.getRegistration('/');
  if (reg?.active?.scriptURL.endsWith('/service-worker.js')) {
    await owner(null);
    const sub = await reg.pushManager.getSubscription();
    if (sub) await sub.unsubscribe();
  }
}
